/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createTypeOf } from '../../factoriesAny.js';
export var typeOfDependencies = {
  typedDependencies,
  createTypeOf
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesTypeOf.generated.js
// module id = null
// module chunks = 